import React, { Component } from 'react';
import {connect} from 'react-redux';

import { Button, Grid, IconButton, Modal } from '@material-ui/core';
import { getIssuesByCommunity, delIssueByCommunity } from '../../actions/issueAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAlphaDown, faSortAlphaUpAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import AddEditIssue from './AddEditIssue';




class IssuesList extends Component {
    constructor(props){
        super(props);

        this.state = {
           sortDesc: true,
           characterLimit:30,
           openIssues:false,
           selectedIssue:undefined,
           SweetAlertStyles: {modalStyles:{backgroundColor: '#ffffff'}, messageClass:'LAlertMessageStyles'},

        }

    }

    componentDidMount(){
        this.getIssues();
    }

    componentDidUpdate(prevProps){
        if(prevProps.communityId!==this.props.communityId){
            this.setState({
                sortDesc:true
            })
        }
    }

    getIssues =()=>{
        this.props.getIssuesByCommunity(localStorage.getItem('communityId'), this.state.sortDesc);

    }

    handleSort =()=>{
        this.setState((prevState)=>({sortDesc:!prevState.sortDesc}), ()=>this.getIssues())
    }

    handleUpdate=(e, issue)=>{
        this.setState({selectedIssue:issue, openIssues:true})
    }

    handleDelete=(e, id)=>{
        this.props.delIssueByCommunity(id, this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});
    }

    handleClose=()=>{
        this.setState({openIssues:false, selectedIssue:undefined}, ()=>this.getIssues());
        
    }



    render() {
        return (
            <>
                <Grid item container xs={12} justifyContent='center' alignContent='flex-start' className='setUpsectionContainer'>
                    {/* Title and button */}
                    <Grid item container xs={12} justifyContent='space-between'  alignItems='flex-start'>
                        <Grid item className='LsetUpTitle'>{`Issues (${this.props.issues?this.props.issues.length:0})`}</Grid>

                        <Button className='Lsetup_btn' onClick={()=>this.setState({openIssues:true})}>
                            Add Issue
                        </Button>
                    </Grid>


                    <Grid item xs={12} className='LRepairsOpenedHeaders' style={{paddingLeft:'20px', paddingTop:'20px'}}>
                        Issue Description
                        <IconButton onClick={this.handleSort}>
                            <FontAwesomeIcon icon={this.state.sortDesc? faSortAlphaDown: faSortAlphaUpAlt} color='#a2a1a2' />
                        </IconButton>
                    </Grid>

                    <Grid item container xs={12}  className="roomsContainer">
                        {
                            this.props.issues && this.props.issues.map((issue, index)=>{
                                return(
                                    <Grid item container xs={12} key={issue._id} className='roomRow'
                                        style={{backgroundColor:(index%2!==0)?'#fafafa':'transparent'}}
                                        justifyContent='space-between' alignItems='center'
                                    >
                                        <Grid item xs={9} lg={10} style={{paddingLeft:'10px', cursor:'pointer'}}
                                            onClick={(e)=>this.handleUpdate(e, issue)}
                                        >
                                            {issue.name}
                                        </Grid>

                                        <IconButton onClick={(e)=>this.handleDelete(e, issue._id)}>
                                            <FontAwesomeIcon icon={faTrashAlt} color='#c55e42' size='sm'/>
                                        </IconButton>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>

                   


                </Grid>

                <Modal
                    open={this.state.openIssues}
                    style={{ borderRadius: '16px' }}
                    onClose={this.handleClose}
                >
                    <AddEditIssue
                        close={this.handleClose}
                        characterLimit={this.state.characterLimit}
                        data={this.state.selectedIssue}
                    />
                </Modal>
            </>
        )
    }
}

function mapStateToProps(state,dispatch) {
    let issues = (state.issueReducer && state.issueReducer.issueData) ? state.issueReducer.issueData : [];

    return{
        issues
    }
};

export default connect(mapStateToProps,{getIssuesByCommunity, delIssueByCommunity})(IssuesList)

